const NEW_ID = -1;

const TYPE_INFOGRAPHIC = 'info-graphic';
const TYPE_INFO = 'info';
const TYPE_HERO = 'hero';
const TYPE_QUESTION = 'question';
const TYPE_ACTION = 'action';
const TYPE_INITIATIVE = 'initiative';
const TYPE_INITIATIVE_BY_CONTENT_EDITOR = 'initiative-by-content-editor';
const TYPE_ACTIONS_INITIATIVES = 'actions/initiatives';

export {
  NEW_ID,
  TYPE_INFOGRAPHIC,
  TYPE_INFO,
  TYPE_HERO,
  TYPE_ACTION,
  TYPE_INITIATIVE,
  TYPE_INITIATIVE_BY_CONTENT_EDITOR,
  TYPE_QUESTION,
  TYPE_ACTIONS_INITIATIVES,
};
